import { render, staticRenderFns } from "./RemindersFilter.vue?vue&type=template&id=6f3efe58"
import script from "./RemindersFilter.vue?vue&type=script&lang=js"
export * from "./RemindersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports